module.exports = __webpack_public_path__ + "img/Background-Small-Mounted-Prints-2366x901-.7caef388.jpeg";